import { IError } from "../types/errors";
import { ActionType } from "../types/store-types";

export enum IntegrationActionTypes {
    GET_ZAPIER_AUTH_URL_REQUEST = "AUTH.GET_ZAPIER_AUTH_URL_REQUEST",
    GET_ZAPIER_AUTH_URL_SUCCESS = "AUTH.GET_ZAPIER_AUTH_URL_SUCCESS",
    GET_ZAPIER_AUTH_URL_FAILURE = "AUTH.GET_ZAPIER_AUTH_URL_FAILURE",

    GET_ZAPIER_ZAPS_REQUEST = "AUTH.GET_ZAPIER_ZAPS_REQUEST",
    GET_ZAPIER_ZAPS_SUCCESS = "AUTH.GET_ZAPIER_ZAPS_SUCCESS",
    GET_ZAPIER_ZAPS_FAILURE = "AUTH.GET_ZAPIER_ZAPS_FAILURE",

    GET_ZAPIER_TOKENS_REQUEST = "AUTH.GET_ZAPIER_TOKENS_REQUEST",
    GET_ZAPIER_TOKENS_SUCCESS = "AUTH.GET_ZAPIER_TOKENS_SUCCESS",
    GET_ZAPIER_TOKENS_FAILURE = "AUTH.GET_ZAPIER_TOKENS_FAILURE",

    DISCONNECT_ZAPIER_REQUEST = "AUTH.DISCONNECT_ZAPIER_REQUEST",
    DISCONNECT_ZAPIER_SUCCESS = "AUTH.DISCONNECT_ZAPIER_SUCCESS",
    DISCONNECT_ZAPIER_FAILURE = "AUTH.DISCONNECT_ZAPIER_FAILURE",

    GET_HUBSPOT_AUTH_URL_REQUEST = "AUTH.GET_HUBSPOT_AUTH_URL_REQUEST",
    GET_HUBSPOT_AUTH_URL_SUCCESS = "AUTH.GET_HUBSPOT_AUTH_URL_SUCCESS",
    GET_HUBSPOT_AUTH_URL_FAILURE = "AUTH.GET_HUBSPOT_AUTH_URL_FAILURE",

    GET_HUBSPOT_DATA_REQUEST = "AUTH.GET_HUBSPOT_DATA_REQUEST",
    GET_HUBSPOT_DATA_SUCCESS = "AUTH.GET_HUBSPOT_DATA_SUCCESS",
    GET_HUBSPOT_DATA_FAILURE = "AUTH.GET_HUBSPOT_DATA_FAILURE",

    GET_HUBSPOT_STATUS_REQUEST = "AUTH.GET_HUBSPOT_STATUS_REQUEST",
    GET_HUBSPOT_STATUS_SUCCESS = "AUTH.GET_HUBSPOT_STATUS_SUCCESS",
    GET_HUBSPOT_STATUS_FAILURE = "AUTH.GET_HUBSPOT_STATUS_FAILURE",

    UPDATE_HUBSPOT_PROPERTY_REQUEST = "AUTH.UPDATE_HUBSPOT_PROPERTY_REQUEST",
    UPDATE_HUBSPOT_PROPERTY_SUCCESS = "AUTH.UPDATE_HUBSPOT_PROPERTY_SUCCESS",
    UPDATE_HUBSPOT_PROPERTY_FAILURE = "AUTH.UPDATE_HUBSPOT_PROPERTY_FAILURE",

    GET_HUBSPOT_TABLES_REQUEST = "AUTH.GET_HUBSPOT_TABLES_REQUEST",
    GET_HUBSPOT_TABLES_SUCCESS = "AUTH.GET_HUBSPOT_TABLES_SUCCESS",
    GET_HUBSPOT_TABLES_FAILURE = "AUTH.GET_HUBSPOT_TABLES_FAILURE",

    DISCONNECT_INTEGRATION_REQUEST = "AUTH.DISCONNECT_INTEGRATION_REQUEST",
    DISCONNECT_INTEGRATION_SUCCESS = "AUTH.DISCONNECT_INTEGRATION_SUCCESS",
    DISCONNECT_INTEGRATION_FAILURE = "AUTH.DISCONNECT_INTEGRATION_FAILURE",

    GET_GOOGLESHEETS_AUTH_URL_REQUEST = "AUTH.GET_GOOGLESHEETS_AUTH_URL_REQUEST",
    GET_GOOGLESHEETS_AUTH_URL_SUCCESS = "AUTH.GET_GOOGLESHEETS_AUTH_URL_SUCCESS",
    GET_GOOGLESHEETS_AUTH_URL_FAILURE = "AUTH.GET_GOOGLESHEETS_AUTH_URL_FAILURE",

    GET_GOOGLESHEETS_REQUEST = "AUTH.GET_GOOGLESHEETS_REQUEST",
    GET_GOOGLESHEETS_SUCCESS = "AUTH.GET_GOOGLESHEETS_SUCCESS",
    GET_GOOGLESHEETS_FAILURE = "AUTH.GET_GOOGLESHEETS_FAILURE",

    UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST = "AUTH.UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST",
    UPDATE_GOOGLE_SHEETS_CONFIG_SUCCESS = "AUTH.UPDATE_GOOGLE_SHEETS_CONFIG_SUCCESS",
    UPDATE_GOOGLE_SHEETS_CONFIG_FAILURE = "AUTH.UPDATE_GOOGLE_SHEETS_CONFIG_FAILURE",

    GET_GOOGLE_SHEET_WORKSHEETS_REQUEST = "AUTH.GET_GOOGLE_SHEET_WORKSHEETS_REQUEST",
    GET_GOOGLE_SHEET_WORKSHEETS_SUCCESS = "AUTH.GET_GOOGLE_SHEET_WORKSHEETS_SUCCESS",
    GET_GOOGLE_SHEET_WORKSHEETS_FAILURE = "AUTH.GET_GOOGLE_SHEET_WORKSHEETS_FAILURE",

    GET_INTEGRATION_STATUSES_REQUEST = "AUTH.GET_INTEGRATION_STATUSES_REQUEST",
    GET_INTEGRATION_STATUSES_SUCCESS = "AUTH.GET_INTEGRATION_STATUSES_SUCCESS",
    GET_INTEGRATION_STATUSES_FAILURE = "AUTH.GET_INTEGRATION_STATUSES_FAILURE",

    GET_MAILCHIMP_AUTH_URL_REQUEST = "AUTH.GET_MAILCHIMP_AUTH_URL_REQUEST",
    GET_MAILCHIMP_AUTH_URL_SUCCESS = "AUTH.GET_MAILCHIMP_AUTH_URL_SUCCESS",
    GET_MAILCHIMP_AUTH_URL_FAILURE = "AUTH.GET_MAILCHIMP_AUTH_URL_FAILURE",

    UPDATE_MAILCHIMP_CONFIG_REQUEST = "UPDATE_MAILCHIMP_CONFIG_REQUEST",
    UPDATE_MAILCHIMP_CONFIG_SUCCESS = "UPDATE_MAILCHIMP_CONFIG_SUCCESS",
    UPDATE_MAILCHIMP_CONFIG_FAILURE = "UPDATE_MAILCHIMP_CONFIG_FAILURE",

    GET_MAILCHIMP_REQUEST = "AUTH.GET_MAILCHIMP_REQUEST",
    GET_MAILCHIMP_SUCCESS = "AUTH.GET_MAILCHIMP_SUCCESS",
    GET_MAILCHIMP_FAILURE = "AUTH.GET_MAILCHIMP_FAILURE",

    GET_MAILCHIMP_SELECTED_FIELDS_REQUEST = "AUTH.GET_MAILCHIMP_SELECTED_FIELDS_REQUEST",
    GET_MAILCHIMP_SELECTED_FIELDS_SUCCESS = "AUTH.GET_MAILCHIMP_SELECTED_FIELDS_SUCCESS",
    GET_MAILCHIMP_SELECTED_FIELDS_FAILURE = "AUTH.GET_MAILCHIMP_SELECTED_FIELDS_FAILURE",
}

export interface IGetHubspotAuthURLRequestData {
    formId: string;
}

export interface IGetHubspotAuthURLSuccessData {
    success: boolean;
    message: string;
    data: string;
}

export interface IGetHubspotAuthURLFailureData extends IError {
    success: boolean;
    message: string;
    data: string;
}

export interface IGetHubspotDataRequestData {
    formId: string;
}
export interface IGetHubspotDataSuccessData {
    hubspotData: {
        table: string;
        fields: {
            [key: string]: string;
        };
        _id: string;
    };
}

export interface IHubspotDataConfig {
    table: string;
    fields: {
        [key: string]: string;
    };
    _id: string;
}

export interface IHubspotDataConfig {
    success: boolean;
    message: string;
    data: {
        config: IHubspotDataConfig;
    };
}

export interface IGetHubspotDataFailureData extends IError {}

export interface IGetHubspotStatusRequestData {
    formId: string;
}

export interface IGetHubspotStatusSuccessData {
    success: boolean;
    message: string;
    data: string;
}

export interface IGetHubspotStatusFailureData extends IError {}

export interface IUpdateHubspotPropertyData {
    tableName: string;
    fields: {
        [key: string]: string;
    };
    _id?: string;
}

export interface IUpdateHubspotPropertyRequestData {
    formId: string;
    tableName: string;
    fields: {
        [key: string]: string;
    };
}
export interface IUpdateHubspotPropertySuccessData {
    success: boolean;
    message: string;
    data: IUpdateHubspotPropertyData | null;
}

export interface IUpdateHubspotPropertyFailureData extends IError {}

export interface IGetHubspotTablesData extends Array<Record<string, any>> {}

export interface IGetHubspotTablesRequestData {
    formId: string;
    table: string;
}
export interface IGetHubspotTablesSuccessData {
    success: boolean;
    message: string;
    data: IGetHubspotTablesData | null;
}

export interface IGetHubspotTablesFailureData extends IError {}

export interface IGetGoogleSheetsAuthURLRequestData {
    formId: string;
}

export interface IGetGoogleSheetsAuthURLSuccessData {
    success: boolean;
    message: string;
    data: string;
}

export interface IGetGoogleSheetsAuthURLFailureData extends IError {}

export interface IGetGoogleSheetsRequestData {
    formId: string;
}

export interface IGetGoogleSheetsSuccessData {
    success: boolean;
    message: string;
    data: {
        list: Array<{
            id: string;
            name: string;
        }>;
        count: number;
    };
}

export interface IGetGoogleSheetsFailureData extends IError {}

export interface IZapierState {
    isLoading: boolean;
    authUrl: string | null;
    formId: string | null;
    error: string | null;
}
export interface IZapierTokensState {
    isLoading: boolean;
    zapierToken: Record<string, any> | null;
}
export interface IZapierAuthState {
    isLoading: boolean;
    authUrl: string | null;
    formId: string | null;
    error: string | null | IError;
}
export interface IZapierDisconnectionState {
    isLoading: boolean;
    error: string | null | IError;
    success: boolean;
    message: string | null;
}
export interface IGetZapierAuthURLRequestData {
    formId: string | undefined;
}
export interface IZapierDataState {
    zaps: Record<string, any> | null;
    message: string;
    isLoading: boolean;
}
export interface IHubspotAuthState {
    isLoading: boolean;
    authUrl: string | null;
    error: string | null | IError;
}

export interface IHubspotDataState {
    isLoading: boolean;
    error: string | null | IError;
    hubspotData: IHubspotDataConfig | null;
    success: boolean;
    message: string;
}

export interface IHubspotStatusState {
    isLoading: boolean;
    error: string | null | IError;
    status: string | null;
    message: string | null;
    success: string | null | boolean;
}

export interface IHubspotTablesState {
    isLoading: boolean;
    error: string | null | IError;
    hubspotTablesData: Array<Record<string, any>> | null;
    success: boolean;
    message: string;
}

export interface IHubspotPropertyState {
    isLoading: boolean;
    error: string | null | IError;
    hubspotData: IHubspotDataConfig | null;
    success: boolean;
    message: string;
}

export interface IGoogleSheetsState {
    isLoading: boolean;
    authUrl?: string | null;
    error: string | null | IError;
    sheetsData?: Array<{ id: string; name: string }> | null;
    worksheets?: string[] | null;
    config?: any | null;
    success?: boolean;
    message?: string;
}

export interface IIntegrationStatus {
    googleSheet: boolean;
    mailChimp: boolean;
    zapier: boolean;
    hubspot: boolean;
}

export interface IIntegrationStatusesState {
    isLoading: boolean;
    error: string | null | IError;
    statuses: IIntegrationStatus | null;
}

export interface IUpdateGoogleSheetsConfigData {
    userId: string;
    formId: string;
    statusess: {
        googleSheet: boolean;
        mailChimp: boolean;
        zapier: boolean;
    };

    config: {
        googleSheet: {
            targetSheet: string;
            fields: string[];
            subSheetName?: string;
            includeSubDate: boolean;
            includeSubId: boolean;
            includeSubIp: boolean;
            includeAllFields: boolean;
        };
        mailChimp?: {
            listId: string;
            fields: Record<string, any>;
        };
        zapier?: Record<string, any>;
    };
}
export interface IGetGoogleSheetsWorksheetsRequestData {
    formId: string;
    sheetId: string;
}

export interface IGetGoogleSheetsWorksheetsSuccessData {
    success: boolean;
    message: string;
    worksheets: string[];
}

export interface IGetGoogleSheetsWorksheetsFailureData extends IError {}

export interface IUpdateGoogleSheetsConfigRequestData {
    formId: string;
    targetSheet: string;
    fields: string[];
    subSheetName: string;
    includeSubDate: boolean;
    includeSubId: boolean;
    includeSubIp: boolean;
    includeAllFields: boolean;
}

export interface IUpdateGoogleSheetsConfigSuccessData {
    success: boolean;
    message: string;
    data: IUpdateGoogleSheetsConfigData;
}

export interface IUpdateGoogleSheetsConfigFailureData extends IError {}

export interface IGetIntegrationStatusesRequestData {
    formId: string;
    method?: string;
}

export interface IGetIntegrationStatusesSuccessData {
    success: boolean;
    message: string;
    data: {
        googleSheet: boolean;
        mailChimp: boolean;
        zapier: boolean;
        hubspot: boolean;
    };
}

export interface IGetIntegrationStatusesFailureData extends IError {}

export interface IDisconnectIntegrationData {
    userId: string;
    formId: string;
    statusess: {
        googleSheet: boolean;
        mailChimp: boolean;
        zapier: boolean;
    };
    config: {
        googleSheet: {
            targetSheet: string;
            fields: string[];
            subSheetName?: string;
            includeSubDate: boolean;
            includeSubId: boolean;
            includeSubIp: boolean;
            includeAllFields: boolean;
        };
        mailChimp?: {
            listId: string;
            fields: Record<string, any>;
        };
        zapier?: Record<string, any>;
    };
}

export interface IDisconnectIntegrationState {
    success: boolean;
    message: string | null;
    data: IDisconnectIntegrationData | null;
}
export interface IDisconnectIntegrationFailureData extends IError {}
export interface IDisconnectIntegrationRequestData {
    type: string;
}
export interface IDisconnectIntegrationSuccessData {
    success: boolean;
    message: string;
    data: IDisconnectIntegrationData;
}

export interface IGetZapierAuthURLSuccessData {
    authUrl: string;
    formId: string;
}

export interface IGetZapierAuthURLFailureData extends IError {}

export interface IMailchimpListsState {
    isLoading: boolean;
    error: string | null | IError;
    mailchimpData?: Record<string, any>;
}

export interface IMailchimpSelectedFieldsState {
    isLoading: boolean;
    error: string | null | IError;
    selectedFields?: Record<string, any>;
}

export interface IMailchimpAuthState {
    isLoading: boolean;
    authUrl?: string | null;
    error: string | null | IError;
}

export interface IMailchimpConfigState {
    isLoading: boolean;
    error: string | null | IError;
    configData?: Record<string, any>;
}
/* - Mailchimp auth url - */

export interface IGetMailchimpAuthURLRequestData {
    formId: string;
}

export interface IGetMailchimpAuthURLSuccessData {
    success: boolean;
    message: string;
    data: string;
}

export interface IGetMailchimpAuthURLFailureData extends IError {}

/* - Update Mailchimp Config - */

export interface IUpdateMailchimpConfigData {
    userId: string;
    formId: string;
    statusess: {
        googleSheet: boolean;
        mailChimp: boolean;
        zapier: boolean;
    };
    config: {
        googleSheet: {
            targetSheet: string;
            fields: string[];
            subSheetName?: string;
            startFrom?: string;
        };
        mailChimp?: {
            listId: string;
            fields: Record<string, any>;
        };
        zapier?: Record<string, any>;
    };
}

export interface IUpdateMailchimpConfigRequestData {
    formId: string;
    listId: string;
    fields: Record<string, any>;
}
export interface IUpdateMailchimpConfigSuccessData {
    success: boolean;
    message: string;
    data: IUpdateMailchimpConfigData;
}
export interface IUpdateMailchimpConfigFailureData extends IError {}

/* - Get Mailchimp Lists- */
export interface IGetMailchimpRequestData {
    formId: string;
}

export interface IGetMailchimpSuccessData {
    success: boolean;
    message: string;
    mailchimpData: Record<string, any>;
}

export interface IGetMailchimpFailureData extends IError {}

/* - Mailchimp Selected Fields - */

export interface IGetMailchimpSelectedFieldsRequestData {
    formId: string;
    listId: string;
}
export interface IGetMailchimpSelectedFieldsSuccessData {
    success: boolean;
    message: string;
    selectedFields: Record<string, any>;
}
export interface IGetMailchimpSelectedFieldsFailureData extends IError {}

export type GetZapierAuthURLRequestActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_AUTH_URL_REQUEST,
    IGetZapierAuthURLRequestData
>;

export type GetZapierAuthURLSuccessActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_AUTH_URL_SUCCESS,
    IGetZapierAuthURLSuccessData
>;
export type GetZapierAuthURLFailureActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_AUTH_URL_FAILURE,
    IGetZapierAuthURLFailureData
>;
export interface IGetZapierZapsRequestData {
    formId: string;
}

export interface IGetZapierZapsSuccessData {
    success: boolean;
    message: string;
    data: any;
}

export interface IGetZapierTokensRequestData {
    formId: string | null;
}
export interface IGetZapierTokensSuccessData {
    success: boolean;
    message: string;
    data: Record<string, any>;
}
export interface IGetZapierTokensFailureData extends IError {}

export interface IGetZapierZapsFailureData extends IError {}
export interface IDisconnectZapierRequestData {
    formId: string;
}
export interface IDisconnectZapierSuccessData {
    success: boolean;
    message: string;
    data: IDisconnectIntegrationData;
}
export interface IDisconnectZapierFailureData extends IError {}
export type GetZapierZapsRequestActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_ZAPS_REQUEST,
    IGetZapierZapsRequestData
>;

export type GetZapierZapsSuccessActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_ZAPS_SUCCESS,
    IGetZapierZapsSuccessData
>;

export type GetZapierZapsFailureActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_ZAPS_FAILURE,
    IGetZapierZapsFailureData
>;
export type GetZapierTokensRequestActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_TOKENS_REQUEST,
    IGetZapierTokensRequestData
>;

export type GetZapierTokensSuccessActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_TOKENS_SUCCESS,
    IGetZapierTokensSuccessData
>;

export type GetZapierTokensFailureActionType = ActionType<
    IntegrationActionTypes.GET_ZAPIER_TOKENS_FAILURE,
    IGetZapierTokensFailureData
>;

export type DisconnectZapierRequestActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_ZAPIER_REQUEST,
    IDisconnectZapierRequestData
>;
export type DisconnectZapierSuccessActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_ZAPIER_SUCCESS,
    IDisconnectZapierSuccessData
>;
export type DisconnectZapierFailureActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_ZAPIER_FAILURE,
    IDisconnectZapierFailureData
>;
export interface IDisconnectIntegrationState {
    success: boolean;
    message: string | null;
    data: IDisconnectIntegrationData | null;
}

export interface IDisconnectIntegrationSuccessData {
    success: boolean;
    message: string;
    data: IDisconnectIntegrationData;
}

export interface IDisconnectIntegrationFailureData extends IError {}

export type GetHubspotAuthURLRequestActionType = {
    type: IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST;
};
export type GetHubspotAuthURLSuccessActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_SUCCESS,
    IGetHubspotAuthURLSuccessData
>;
export type GetHubspotAuthURLFailureActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_FAILURE,
    IGetHubspotAuthURLFailureData
>;
export type GetHubspotDataRequestActionType = {
    type: IntegrationActionTypes.GET_HUBSPOT_DATA_REQUEST;
};
export type GetHubspotDataSuccessActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_DATA_SUCCESS,
    IHubspotDataConfig
>;
export type GetHubspotDataFailureActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_DATA_FAILURE,
    IGetHubspotDataFailureData
>;
export type GetHubspotStatusRequestActionType = {
    type: IntegrationActionTypes.GET_HUBSPOT_STATUS_REQUEST;
};
export type GetHubspotStatusSuccessActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_STATUS_SUCCESS,
    IGetHubspotStatusSuccessData
>;
export type GetHubspotStatusFailureActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_STATUS_FAILURE,
    IGetHubspotStatusFailureData
>;

export type UpdateHubspotPropertyRequestActionType = ActionType<
    IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST,
    IUpdateHubspotPropertyRequestData
>;
export type UpdateHubspotPropertySuccessActionType = ActionType<
    IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_SUCCESS,
    IUpdateHubspotPropertySuccessData
>;
export type UpdateHubspotPropertyFailureActionType = ActionType<
    IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_FAILURE,
    IUpdateHubspotPropertyFailureData
>;

export type GetHubspotTablesRequestActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_TABLES_REQUEST,
    IGetHubspotTablesRequestData
>;
export type GetHubspotTablesSuccessActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_TABLES_SUCCESS,
    IGetHubspotTablesSuccessData
>;
export type GetHubspotTablesFailureActionType = ActionType<
    IntegrationActionTypes.GET_HUBSPOT_TABLES_FAILURE,
    IGetHubspotTablesFailureData
>;

export interface IDisconnectIntegrationRequestData {
    type: string;
}

export type DisconnectIntegrationRequestActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_INTEGRATION_REQUEST,
    IDisconnectIntegrationRequestData
>;

export type DisconnectIntegrationSuccessActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_INTEGRATION_SUCCESS,
    IDisconnectIntegrationSuccessData
>;

export type DisconnectIntegrationFailureActionType = ActionType<
    IntegrationActionTypes.DISCONNECT_INTEGRATION_FAILURE,
    IDisconnectIntegrationFailureData
>;

export type GetGoogleSheetsAuthURLRequestActionType = {
    type: IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_REQUEST;
};

export type GetGoogleSheetsAuthURLSuccessActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_SUCCESS,
    IGetGoogleSheetsAuthURLSuccessData
>;
export type GetGoogleSheetsAuthURLFailureActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_FAILURE,
    IGetGoogleSheetsAuthURLFailureData
>;

export type GetGoogleSheetsRequestActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLESHEETS_REQUEST,
    IGetGoogleSheetsRequestData
>;

export type GetGoogleSheetsSuccessActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLESHEETS_SUCCESS,
    IGetGoogleSheetsSuccessData
>;

export type GetGoogleSheetsFailureActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLESHEETS_FAILURE,
    IGetGoogleSheetsFailureData
>;
export type UpdateGoogleSheetsConfigRequestActionType = ActionType<
    IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST,
    IUpdateGoogleSheetsConfigRequestData
>;

export type UpdateGoogleSheetsConfigSuccessActionType = ActionType<
    IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_SUCCESS,
    IUpdateGoogleSheetsConfigSuccessData
>;

export type UpdateGoogleSheetsConfigFailureActionType = ActionType<
    IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_FAILURE,
    IUpdateGoogleSheetsConfigFailureData
>;

export type GetGoogleSheetWorksheetsRequestActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_REQUEST,
    IGetGoogleSheetsWorksheetsRequestData
>;

export type GetGoogleSheetWorksheetsSuccessActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_SUCCESS,
    IGetGoogleSheetsWorksheetsSuccessData
>;

export type GetGoogleSheetWorksheetsFailureActionType = ActionType<
    IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_FAILURE,
    IGetGoogleSheetsWorksheetsFailureData
>;

export type GetIntegrationStatusesRequestActionType = ActionType<
    IntegrationActionTypes.GET_INTEGRATION_STATUSES_REQUEST,
    IGetIntegrationStatusesRequestData
>;

export type GetIntegrationStatusesSuccessActionType = ActionType<
    IntegrationActionTypes.GET_INTEGRATION_STATUSES_SUCCESS,
    IGetIntegrationStatusesSuccessData
>;

export type GetIntegrationStatusesFailureActionType = ActionType<
    IntegrationActionTypes.GET_INTEGRATION_STATUSES_FAILURE,
    IGetIntegrationStatusesFailureData
>;

export interface IIntegrationsState {
    sheets: {
        auth: IGoogleSheetsState;
        data: IGoogleSheetsState;
        worksheets: IGoogleSheetsState;
        config: IGoogleSheetsState;
    };
    hubspot: {
        auth: IHubspotAuthState;
        data: IHubspotDataState;
        status: IHubspotStatusState;
        tables: IHubspotTablesState;
        property: IHubspotPropertyState;
    };
    zapier: {
        auth: IZapierState;
        zapsData: IZapierDataState;
        token: Record<string, any>;
    };
    mailchimp: {
        auth: IMailchimpAuthState;
        selectedFields: IMailchimpSelectedFieldsState;
        lists: IMailchimpListsState;
        config: IMailchimpConfigState;
    };
    statuses: IIntegrationStatusesState;
}

export type GetMailchimpAuthURLRequestActionType = {
    type: IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_REQUEST;
};

export type GetMailchimpAuthURLSuccessActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_SUCCESS,
    IGetMailchimpAuthURLSuccessData
>;
export type GetMailchimpAuthURLFailureActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_FAILURE,
    IGetMailchimpAuthURLFailureData
>;

export type UpdateMailchimpConfigRequestActionType = ActionType<
    IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_REQUEST,
    IUpdateMailchimpConfigRequestData
>;
export type UpdateMailchimpConfigSuccessActionType = ActionType<
    IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_SUCCESS,
    IUpdateMailchimpConfigSuccessData
>;
export type UpdateMailchimpConfigFailureActionType = ActionType<
    IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_FAILURE,
    IUpdateMailchimpConfigFailureData
>;

export type GetMailchimpRequestActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_REQUEST,
    IGetMailchimpRequestData
>;
export type GetMailchimpSuccessActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_SUCCESS,
    IGetMailchimpSuccessData
>;
export type GetMailchimpFailureActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_FAILURE,
    IGetMailchimpFailureData
>;

export type GetMailchimpSelectedFieldsRequestActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_REQUEST,
    IGetMailchimpSelectedFieldsRequestData
>;
export type GetMailchimpSelectedFieldsSuccessActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_SUCCESS,
    IGetMailchimpSelectedFieldsSuccessData
>;
export type GetMailchimpSelectedFieldsFailureActionType = ActionType<
    IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_FAILURE,
    IGetMailchimpSelectedFieldsFailureData
>;
